// The one card recipe: warm fill, hairline edge, one soft shadow. The radius
// token says what it holds: card for lists, hero for art, control for banners.
import type { HTMLAttributes } from 'react';
import { cx } from './cx';

export type CardRadius = 'card' | 'hero' | 'control';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  radius?: CardRadius;
  /** Adds the card's inner padding; lists and rows keep their own. */
  padded?: boolean;
  as?: 'div' | 'section' | 'article' | 'li' | 'figure';
}

export function Card({ radius = 'card', padded, as: Tag = 'div', className, ...rest }: CardProps) {
  return <Tag className={cx('card', radius !== 'card' && radius, padded && 'padded', className)} {...rest} />;
}
